import { atom } from 'recoil';
import defaultTheme from '@ecp/common/src/style/theme/default';

export const themeState = atom({
    key: 'themeState',
    default: defaultTheme,
});
